module.exports = __webpack_public_path__ + "img/PF_NATAL.a858e483.png";